// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__6j5rx","col":"Table_col__23mmx","fulfillmentStatus":"Table_fulfillmentStatus__24Vhp","emailCol":"Table_emailCol__2inhR"};